import Alert from '@storeblocks/alert';
import { WrapLgMarginBottom } from 'App/global-style';
import { externalLink } from 'App/themes/PartnerTheme/partnerTheme.helpers';
import { BUY_INSURANCE_LINK } from 'Constants/url.constants';
import { useFormStatus } from 'Forms/forms.hooks';
import React from 'react';
import { NavLink } from 'react-router';
import { getAppText } from 'Utils/text';
import { isDefined } from 'Utils/type.utils';
import { CancelReasonAkaHouseContents } from '../cancelAkaHouseContentsForm.constants';
import { CancelAkaHouseContentsFormValues } from '../cancelAkaHouseContentsForm.types';

interface CancelAkaHouseContentsFormAlertsProps {
  formValues: CancelAkaHouseContentsFormValues;
  isSubmitting: boolean;
}

export const CancelAkaHouseContentsFormAlerts = ({
  formValues,
  isSubmitting,
}: CancelAkaHouseContentsFormAlertsProps): React.ReactElement | null => {
  const { cancelReason } = formValues;
  const { submitSuccess } = useFormStatus();

  if (
    !isDefined(cancelReason) ||
    isSubmitting ||
    submitSuccess ||
    cancelReason === CancelReasonAkaHouseContents.INSURED_VIA_PARTNER ||
    cancelReason === CancelReasonAkaHouseContents.INSURED_VIA_UNION
  ) {
    return null;
  }

  const movedAlert = (
    <Alert title={getAppText('cancel.akaHouseContents.alertMovedOrSold.title')}>
      <NavLink
        to={externalLink(BUY_INSURANCE_LINK.AKA_HOUSE_CONTENTS)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {getAppText('cancel.akaHouseContents.alertMovedOrSold.link')}
      </NavLink>
    </Alert>
  );
  const notInNeedAlert = (
    <Alert
      title={getAppText(
        'cancel.akaHouseContents.cancelReason.alertOtherReason.title',
      )}
    />
  );

  return (
    <WrapLgMarginBottom>
      {cancelReason === CancelReasonAkaHouseContents.MOVED_OR_SOLD &&
        movedAlert}
      {cancelReason === CancelReasonAkaHouseContents.NOT_IN_NEED &&
        notInNeedAlert}
    </WrapLgMarginBottom>
  );
};
